import { useBlogCardWebContext } from "./BlogCardWebProvider";
import useImageSize from "../../../../hooks/global/useImageSize";

export const BlogCardWebImage = () => {
  const { state } = useBlogCardWebContext();
  const [imageUrl] = useImageSize({
    imageUrl: state.blog.coverImage,
    isCover: true,
    size: 1000,
  });

  return (
    <img
      title={state.blog.title}
      alt={state.blog.title}
      src={imageUrl}
      className={
        "rounded-[1.75rem] w-[20rem] xl:w-[25rem] 2xl:w-[28rem] aspect-video ml-auto object-cover"
      }
    />
  );
};
